import { SVGProps } from 'react'

type FowardArrowIconProps = SVGProps<SVGSVGElement>

const FowardArrowIcon = ({ className, ...props }: FowardArrowIconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={28}
    height={21}
    fill="none"
    className={className}
    {...props}
  >
    <path
      fill="#fff"
      d="M28 10.372 15.214 0v5.636h-3.131c-11.351 0-13.569 8.35-10.96 14.482.522-5.61 7.73-5.48 12.917-5.48h1.174v6.107L28 10.372Z"
    />
  </svg>
)
export default FowardArrowIcon
